module.exports = __webpack_public_path__ + "static/media/diver.fe95c7c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameOceanCleanup/diver.png
// module id = 2558
// module chunks = 0